import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { EmtTypography } from "./EmtTypography";
import { styled } from "@mui/material/styles";
export type EmtLoaderProps = CircularProgressProps & {
  /**
   * Show loader in fixed top position
   * @default false
   */
  isHeader?: boolean;
  /**
   * Text display in right of the loader
   * @default Loading...
   */
  headerText?: string;
  nonce?: string;
};

const Header = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  height: "40px",
  width: "100%",
  background: theme.palette.common.white,
  boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.1)",
  zIndex: 12000,
}));

const HeaderContent = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  gap: "8px",
}));

export function EmtLoader(props: EmtLoaderProps) {
  const { isHeader = false, headerText = "Loading...", size, ...rest } = props;

  return isHeader ? (
    <Header>
      <HeaderContent>
        <CircularProgress size={16} {...rest} />
        <EmtTypography variant="caption" color="primary">
          {headerText}
        </EmtTypography>
      </HeaderContent>
    </Header>
  ) : (
    <CircularProgress size={size} {...rest} />
  );
}
